import React from 'react'
import { useLocation } from 'react-router-dom'
import { useState } from 'react'
import Agree from './Agree'
import BarLoader from 'react-spinners/BarLoader'
import ShareBtn from '../ShareBtn'

// 三支問卷內容完全一致，受訪者從 /P260817111456476 進入後隨機分流到其中一支。
// 網址不變，只有送出答案時綁定的 pid 不同。
// 另兩支已加進 App.js 的 notUsedIds，直接以網址訪問會顯示 404。
const pidArr = ['P260817111456476', 'P260818103532680', 'P260818103653739']

function shuffle(array) {
  const shuffled = [...array]
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]]
  }
  return shuffled
}

function Layout({ setCompletionMessage }) {
  const [ac, setAc] = useState(null)
  const [tk, setTk] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [showShareBtn, setShowShareBtn] = useState(true)

  // 初始化時擲一次；重整頁面會重新隨機
  const [randomPid] = useState(() => {
    const selected = shuffle(pidArr)[0]
    console.log('Random Project ID:', selected)
    return selected
  })

  const { pathname } = useLocation()
  const pid = 'P' + pathname.toLowerCase().split('/p')[1]

  const actualInnerWidth = document.body.clientWidth - 20
  // 分享連結固定用入口網址，不能分享到備用 pid
  const shareUrl = `${window.location.origin}/${pid.toLowerCase()}`

  return (
    <>
      <BarLoader
        cssOverride={{ overflow: 'hidden', position: 'fixed', zIndex: '1021' }}
        color="#19b394"
        width={actualInnerWidth}
        loading={isLoading}
      />

      <Agree
        setIsLoading={setIsLoading}
        pid={randomPid}
        setAc={setAc}
        setTk={setTk}
        ac={ac}
        tk={tk}
        setShowShareBtn={setShowShareBtn}
        setCompletionMessage={setCompletionMessage}
      />
      <ShareBtn showShareBtn={showShareBtn} shareUrl={shareUrl} />
    </>
  )
}

export default Layout
